import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_site_icon = _resolveComponent("site-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialSites, (socialSite) => {
      return (_openBlock(), _createBlock(_component_q_btn, {
        key: socialSite.id,
        size: _ctx.size,
        flat: "",
        round: "",
        class: _normalizeClass('q-mx-' + _ctx.size),
        onClick: ($event: any) => (_ctx.toggle(socialSite.id))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_site_icon, {
            "social-site": socialSite,
            color: _ctx.isSelected(socialSite.id) ? '' : 'grey-6',
            size: _ctx.size
          }, null, 8, ["social-site", "color", "size"])
        ]),
        _: 2
      }, 1032, ["size", "class", "onClick"]))
    }), 128))
  ]))
}